import axios from 'axios';
import { getGlobal, setGlobal } from 'reactn';
import defaultGlobalState from '../defaultGlobalState';

const API_URL = process.env.REACT_APP_API_URL;

export const getUser = () => {
  const { userId } = getGlobal();
  return axios
    .get(`${API_URL}/user/${userId}`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response.status === 401) {
        setGlobal(defaultGlobalState);
        localStorage.removeItem('jwt');
      } else throw err;
    });
};

export const updateUserField = async (input) => {
  const { userId } = getGlobal();
  try {
    await axios.put(`${API_URL}/user/${userId}`, input);
    // after updaing field, refetch user details and save to global state
    const user = await getUser();
    setGlobal({ user });
  } catch (err) {
    if (err.response.status === 401) {
      setGlobal(defaultGlobalState);
      localStorage.removeItem('jwt');
    } else throw err;
  }
};


// add methods to object to handle warning no-anonymous-default-export
const userObject = {
  getUser,
  updateUserField,
};

export default userObject